import { createModule } from "redux-mvc";
import model from "./model";
import sliderSidebar from "ui-kit/SliderSidebar";
import filesModule from "./View/Files";
import participantsModule from "./View/Participants";
import formModule from "ui-kit/Form";
import sessionContentModule from "EventLight/Sessions/SessionContent";
import sagasModule from "./sagas";

const module = createModule({
  ...model,
  observedDomains: [
    "event",
    "permissions",
    "organization",
    "user",
    "portal",
    "accounts",
    "routing",
    "items",
    "@flopflip",
    "modal"
  ]
});

module.setRootSaga(sagasModule);
module.plugModule(formModule);
module.plugModule(filesModule);
module.plugModule(participantsModule);
module.plugModule(sessionContentModule);
module.plugModule(sliderSidebar);

export default module;
